import { render, staticRenderFns } from "./CartDrawer.vue?vue&type=template&id=62513740&scoped=true&"
import script from "./CartDrawer.vue?vue&type=script&lang=js&"
export * from "./CartDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CartDrawer.vue?vue&type=style&index=0&id=62513740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62513740",
  null
  
)

export default component.exports